var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 18,
    viewBox: "0 0 6 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00016 4.66683C4.19183 4.66683 5.16683 3.69183 5.16683 2.50016C5.16683 1.3085 4.19183 0.333496 3.00016 0.333496C1.8085 0.333496 0.833496 1.3085 0.833496 2.50016C0.833496 3.69183 1.8085 4.66683 3.00016 4.66683ZM3.00016 6.8335C1.8085 6.8335 0.833496 7.8085 0.833496 9.00016C0.833496 10.1918 1.8085 11.1668 3.00016 11.1668C4.19183 11.1668 5.16683 10.1918 5.16683 9.00016C5.16683 7.8085 4.19183 6.8335 3.00016 6.8335ZM3.00016 13.3335C1.8085 13.3335 0.833496 14.3085 0.833496 15.5002C0.833496 16.6918 1.8085 17.6668 3.00016 17.6668C4.19183 17.6668 5.16683 16.6918 5.16683 15.5002C5.16683 14.3085 4.19183 13.3335 3.00016 13.3335Z",
    fill: "#F96652"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.6952610c364dc688ea8864ac1a2ea267.svg";
export { ForwardRef as ReactComponent };